import { Image, SelectOption } from '@/interfaces/GeneralInterfaces'
import { Vue } from 'vue/types/vue'

interface FormGenderOption extends SelectOption {
  label: string,
  value: number
}

export interface NationalityOption extends SelectOption {
  label: string,
  value: number
}

export interface User {
  id: number
  firstName: string
  candidateNumber: string | null
  lastName: string
  email: string
  gender: string
  phone?: string
  locale?: string
  image: Image
  dob: string
  dobIsAccurate: boolean
  nationality: Nationality | null
}

export interface UpdateUserData {
  candidateNumber: string | null;
  gender?: number | null
}

export interface UpdateUserDataForm {
  firstName: string
  lastName: string
  candidateNumber: string | null;
  email: string
  gender?: FormGenderOption | null
  phone?: string
  locale?: string
  dob: string
  dobIsAccurate: boolean
  nationality: NationalityOption | null

}

export interface RegistrationData {
  candidateNumber: string | null;
  gender?: number | null
  locale?: string | null

}

export interface RegistrationTsSurveyData extends RegistrationData {
  accessCode: string
}

export interface RegistrationFormData {
  candidateNumber: string | null;
  gender: FormGenderOption | null
  locale?: string | null
}

export interface SignInData {
  candidateNumber: string | null;
  password: string
  accessCode?: string | null
}

export interface LocaleData {
  locale: string
  localeName: string
}

export interface UpdatePasswordData {
  oldPassword: string
  newPassword: string
}

export interface ResetPasswordData {
  newPassword: string
  confirmPassword: string
}

export interface RequestResetPasswordData {
  username: string,
  origin: string
}

export enum ImageActions {
  ADD = 'add',
  CHANGE = 'change'
}

export type Cropper = Vue & {
  setStep: (step: number) => void;
}

export interface Nationality {
  id: number
  nationality: string
}
